
import React from 'react';
import { motion } from 'framer-motion'; // Import Framer Motion

import './NavHome.css';
import { Link } from 'react-router-dom';

const NavHome = () => {
  return (
    <div className='nav-home'>
      {/* Normal Navbar */}
      <div className='nav-cover'>
        <div className='logo'>
          <h2>NERDARR</h2>
        </div>
        <div className='nav-links'>
          <ul>
            <li>Solutions</li>
            <li>Resources</li>
            <li>About Us</li>
          </ul>
        </div>
        <div className='login'>
          <motion.button
            whileHover={{ scale: 1.05 }} // Scale on hover
            whileTap={{ scale: 0.95 }}  // Scale down on tap
            transition={{ duration: 0.2 }}
          >
           <Link style={{color: "white", textDecoration : "none"}} className='link' to="/login">LOGIN</Link>
          </motion.button>
        </div>
      </div>

      {/* Responsive Navbar */}
      <div className='res-nav-cover'>
        <div className='logo'>
          <h2>NERDARR</h2>
        </div>
        <div className='login'>
          <h2><Link className='link' to="/login">Sign in</Link></h2>
        </div>
      </div>
    </div>
  );
};

export default NavHome;




// import React, {useState} from 'react';

// import "./NavHome.css"



// function NavHome() { 
 

//   return <>     
    
//             <div className='HomeNavWhole'>
                
//                 {/* Normal Navbar */}
//                 <div className='HomeNavWholeCover'>  

//                         <div className='FirstHome'> 

//                             <h2>NERDARR</h2>

//                     </div>
//                     <div className='SecondHome'>

//                             <ul>
//                                 <li>Solutions</li>
//                                 <li>Resources</li>
//                                 <li>About Us</li>
//                             </ul>

//                     </div>
//                     <div className='ThirdHome'>
//                             <button>LOGIN</button>
//                     </div>


//                 </div>

//                 {/* Responsive navbar */}
//                 <div className='ResNavHomeCover'>
//                     <div className='firstResNavHomeCover'>
//                         <h2>NERDARR</h2>
//                     </div>
//                     <div className='secResNavHomeCover'>
//                         <h2>LOGIN</h2>

//                     </div>

//                 </div>

                    
//             </div>
   

  
//   </>
  
//   ;
// }

// export default NavHome;